import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IActivity } from "../activitiesModal";

export const getAllActivity = createAsyncThunk(
  "Activity/FindAllActivity",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Activity/FindAllActivity`,
        {
          Title: "",
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Activity:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createActivity = createAsyncThunk(
  "Activity/InsertActivity",
  async (ActivityData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Activity/InsertActivity`,
        ActivityData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Activity:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateActivity = createAsyncThunk(
  "Activity/UpdateActivity",
  async (ActivityData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Activity/UpdateActivity`,
        ActivityData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Activity :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteActivity = createAsyncThunk(
  "Activity/DeleteActivity",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Activity/DeleteActivity`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Activity :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getActivityByID = createAsyncThunk(
  "Activity/FindByIDActivity",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Activity/FindByIDActivity`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        ActivityName: result.ActivityName,
        ActivityURL: result.ActivityURL,
        Duration: result.Duration,
        DifficultyType: result.DifficultyType,
        Availability: result.Availability,
        Description: result.Description,
        ShortDescription: result.ShortDescription,
        WhatsInclude: result.WhatsInclude,
        ImportantTips: result.ImportantTips,
        MetaKeywords: result.MetaKeywords,
        MetaDescription: result.MetaDescription,
        MetaTitle: result.MetaTitle,
        IsShowOnHome: result.IsShowOnHome,
        MainImage: result.MainImage,
        BannerImage: result.BannerImage,
        ActivityBannerImage: result.ActivityBannerImage,
        ActivityTimeline: result.ActivityTimeline
          ? result.ActivityTimeline?.map((e: any) => ({
              ID: e?.ID,
              Title: e?.Title,
              Time: e?.Time,
              Description: e?.Description,
              TimelineImage: e?.Image,
            }))
          : [],
        IsActive: result.IsActive ? 1 : 2,
      } as IActivity;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Activity :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveActivity = createAsyncThunk(
  "Activity/FindAllActiveActivity",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Activity/FindAllActiveActivity`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Activity:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveActivity = createAsyncThunk(
  "Activity/ActiveInActiveActivity",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Activity/ActiveInActiveActivity`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Activity :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// IMAGE UPLOAD

export const ActivityImageUpload = createAsyncThunk(
  "Activity/ActivityImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Activity/ActivityImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Activity Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const TimelineImagesUpload = createAsyncThunk(
  "Activity/ActivityImageMultiUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Activity/ActivityImageMultiUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Activity Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
